import { render, staticRenderFns } from "./FlexMobile.vue?vue&type=template&id=53e5ed1b"
import script from "./FlexMobile.vue?vue&type=script&lang=js"
export * from "./FlexMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports